import styles from 'styles/_colors.css';

export const FILTERTAGS = {
  success: styles['dark-green'],
  warning: styles['dark-orange'],
  danger: styles['dark-red']
};


// WEBPACK FOOTER //
// ./src/uis/elements/Tags/constants.js